export const arrayFlat = <T>(arrays: T[][]) => [].concat.apply([], arrays);